import { useOptionalEditableDocument } from './EditableDocumentContext';

export interface CanvasSelectionState {
  /** Whether the canvas is in an editable context at all (a provider is mounted). */
  isEditable: boolean;
  isSelected: boolean;
  select: () => void;
  deselect: () => void;
}

/**
 * One element's read of the shared canvas selection (LLAMS-610 Part 7). Returns
 * `isEditable: false` and inert callbacks when no `EditableDocumentProvider` is mounted — the
 * default on every route today, so every existing render stays byte-for-byte unchanged.
 */
export function useCanvasSelection(elementId: string): CanvasSelectionState {
  const editable = useOptionalEditableDocument();

  if (!editable) {
    return {
      isEditable: false,
      isSelected: false,
      select: () => undefined,
      deselect: () => undefined
    };
  }

  return {
    isEditable: true,
    isSelected: editable.selectedElementId === elementId,
    select: () => editable.selectElement(elementId),
    deselect: () => editable.selectElement(null)
  };
}
